import { BaseEntity } from "./base-entity";

export class AspNetRolesAction extends BaseEntity{
    RoleID: number = null;
    ActionID: number = null;
    Value: boolean = null;

    Deserialize(input: any){
        this.ID = input.ID;
        this.RoleID = input.RoleID;
        this.ActionID = input.ActionID;
        this.Value = input.Value;

        return this;
    }
}